<template>
    <v-row>
        <v-col cols="12" md="7" lg="8" v-if="!isMobile" class="img-col"/>
        <v-col cols="12" md="5" lg="4">
            <user-form @success="onSuccess"/>
        </v-col>
    </v-row>
</template>

<script>

import UserForm from '@/components/entrance/UserForm'

import {mapState} from 'vuex'

export default {
    components: {
        UserForm
    },
    computed: {
        ...mapState(['loadingUser'])
    },
    mounted() {
        const vm = this
    },
    methods: {
        onSuccess(loaded = false) {
            const vm = this
            if (loaded) {
                vm.$router.push({name: 'confirm-mail'})
            }
        }
    },
    watch: {
        loadingUser(isLoading) {
            if (!isLoading) {
                this.onSuccess(true)
            }
        }
    }
}
</script>

<style scoped>

.img-col {
    position: sticky;
    top: 48px;
    background-size: cover;
    background-position: center;
    height: calc(100vh - 20px);
    background-image: url('../../assets/img/entrance/login_signup_desktop.png');
}

</style>
